import router from '../router';
import helpers, {lastPageYOffset} from '../helpers';

function openMenu() {
	if (helpers.$html.dataset.currentPage !== 'modal') {
		helpers.saveScrollPosition();
		helpers.$body.style.setProperty('top', `-${lastPageYOffset}px`);
		helpers.$html.classList.add('is-lock-scroll');

		helpers.$body.style.setProperty('padding-right', `${helpers.getScrollbarWidth()}px`);
		helpers.$header.style.setProperty('right', `${helpers.getScrollbarWidth()}px`);
	}

	helpers.$header.classList.add('is-menu-opened');
	document.querySelector('.header__menu').classList.remove('is-hidden');
	setTimeout(() => {
		document.querySelector('.header__menu').classList.add('is-active');
	}, 100);
}

function closeMenu() {
	if (helpers.$html.dataset.currentPage !== 'modal') {
		helpers.$body.style.removeProperty('top');
		helpers.$html.classList.remove('is-lock-scroll');
		helpers.$body.style.removeProperty('padding-right');
		helpers.$header.style.removeProperty('right');
		helpers.restoreScrollPosition();
	}

	helpers.$header.classList.remove('is-menu-opened');

	document.querySelector('.header__menu').classList.remove('is-active');

	setTimeout(() => {
		document.querySelector('.header__menu').classList.add('is-hidden');
	}, 500);
}

function toggleMenu(event) {
	event.preventDefault();
	event.stopPropagation();

	if (event.currentTarget.classList.contains('is-active')) {
		event.currentTarget.classList.remove('is-active');
		helpers.dispatcher.trigger('menu-close');
		closeMenu();
	} else {
		event.currentTarget.classList.add('is-active');
		helpers.dispatcher.trigger('menu-open');
		openMenu();
	}
}

function setHeaderStyles() {
	if (window.pageYOffset <= 0) {
		helpers.$header.classList.remove('is-active');
	} else {
		helpers.$header.classList.add('is-active');
	}
}

function init() {
	helpers.$header = document.querySelector('.header');

	setHeaderStyles();
	window.addEventListener('scroll', setHeaderStyles, false);

	const links = document.querySelectorAll('.header__link');
	Array.prototype.forEach.call(links, (item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();

			const url = e.currentTarget.getAttribute('href');

			helpers.dispatcher.trigger('menu-click', {name: e.currentTarget.textContent});
			document.querySelector('.js-burger').classList.remove('is-active');
			closeMenu();

			router.navigate(url);
		});
	});

	document.querySelector('.js-burger').addEventListener('click', toggleMenu, false);
}

export default {
	init,
};
